import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App.vue'
import Header from './components/Header.vue'
import {routes} from './routes';

Vue.use(VueRouter);
Vue.component('app-header', Header);

const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js